import { combineReducers } from 'redux';
import { recipients } from './recipients_reducer';

const rootReducer = combineReducers({
  recipients
});

export default rootReducer;
